import React from 'react';
import { DlpPolicyItem, TabsEnum } from 'src/pages/Policy/utils/types';
import { PolicyProvider } from '@Policy/store';
import General from './General';
import DlpFilter from './Dlp';
import { DlpPolicy } from '../../../Components/DlpPolicyEntry';

const DlpExchangeOnlinePolicy = (props: {
  template: DlpPolicyItem;
  config: any;
  orgId: string;
}) => {
  const { template, config, orgId } = props;
  console.log(template, config, orgId);
  return (
    <PolicyProvider template={template} config={config} orgId={orgId}>
      <DlpPolicy
        tabs={[TabsEnum.general, TabsEnum.dlp]}
        tabPanels={[General, DlpFilter]}
      />
    </PolicyProvider>
  );
};
export default React.memo(DlpExchangeOnlinePolicy);
